export default function Normal_Data_Distribution() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Normal_Data_Distribution</h1>
      <p>Content for Normal_Data_Distribution goes here.</p>
    </div>
  );
}